// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://61.19.210.103:456/' //public IP กรม
  // apiUrl : 'http://172.17.2.103:456/' //เครื่องที่กรม
  // apiUrl: 'http://192.168.100.148/bigdata/' //เครื่อง CAT
  // apiUrl: 'http://122.155.201.148/bigdata/' //public เครื่อง CAT
  apiUrl: 'https://bigdata_api.cpd.go.th/', //public เครื่อง CAT ของจริ๊งง

  // apiUrl2: 'https://bigdata_api.cpd.go.th/apibigdata_year/', //public เครื่อง CAT ของจริ๊งง2

  apiUrl2: 'https://bigdata_api.cpd.go.th/apitest/', // New UAT

  // apiUrl: 'https://localhost:5001/'

  version: "Version : 3.02 13/07/69"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
